import { lazy } from "react"

const WelcomePage$$__react__lazy__component = lazy(() => 
    import("./WelcomePage__original__module.mjs")
        .then(module => module.get_$$WelcomePage$$WelcomePage$$react__component$$1nzaxw7oc90ja())
        .then(component => ({ default: component }))
)

export const get_$$WelcomePage$$WelcomePage$$react__component$$1nzaxw7oc90ja = () => WelcomePage$$__react__lazy__component